import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import MaterialTable from '../../components/MaterialTable/MaterialTable';
import { getMaterialRequestAction } from '../../store/material/materialActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import './Material.scss';

const Material = ({ materialList, materialData, getMaterialRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getMaterialRequest({});
  }, []);

  const handleCreateMaterial = () => {
    navigate('/material/create');
  };

  return (
    <div className="order-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('material')}</div>
        <MaterialTable materialList={materialList} materialData={materialData} />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateMaterial}
        title={t('create')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  materialData: state.materialReducer.materialData,
  materialList: state.materialReducer.materialList,
});

const mapDispatchToProps = (dispatch) => ({
  getMaterialRequest: (payload) => dispatch(getMaterialRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Material);
